const TakeoverSubType = Object.freeze({
  TAKEOVER: "TAKEOVER",
  SCHEME_OF_ARRANGEMENT: "SCHEME_OF_ARRANGEMENT",
  OTHER: "OTHER",
});

export default TakeoverSubType;
